import { render } from "./PanelTopDown.vue?vue&type=template&id=1ab2677c"
import script from "./PanelTopDown.vue?vue&type=script&lang=js"
export * from "./PanelTopDown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__